import type { FC } from 'react';
import React from 'react';

import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';
import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { SquareTooltipIcon } from '@wwe-portal/ui/components/icons';
import { useTooltipOpen } from '@wwe-portal/ui/components/tooltip/use-tooltip';

export const CategoryTitleTooltip: FC<{
  tooltipContent: React.ReactNode;
}> = ({ tooltipContent }) => {
  const { open, onOpenChange, trigger } = useTooltipOpen();

  return (
    <Tooltip onOpenChange={onOpenChange} open={open}>
      <TooltipTrigger asChild>
        <ClickableDiv onClick={trigger}>
          <SquareTooltipIcon />
        </ClickableDiv>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent className="max-w-48 overflow-auto break-words">
          {tooltipContent}
          <TooltipArrow />
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
